import noop from '../../../../Shared/Util/noop';
import IContainerContextProps from '../Interfaces/IContainerContextProps';

const fallbackContainerContextValue: IContainerContextProps = {
    parentContainerId: '',
    parentContainerOrConnectorId: '',
    registerFocusable: noop,
    unregisterFocusable: noop,
};

export default fallbackContainerContextValue;
